import { p as proxyCustomElement, H, h, c as Host } from './p-92c4a1ea.js';
import { b as generateElementId } from './p-a57042e3.js';
import { b as accessibility } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
const progressBarCss = "@-webkit-keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}100%{left:100%;right:-90%}}@keyframes indeterminate{0%{left:-35%;right:100%}60%{left:100%;right:-90%}100%{left:100%;right:-90%}}.sc-owc-progress-bar-h{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;gap:var(--one-spacing-gap-4-xs);width:100%}.sc-owc-progress-bar-h label.sc-owc-progress-bar{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-caption-font-size);line-height:var(--one-typography-desktop-caption-line-height);-webkit-font-kerning:var(--one-typography-desktop-caption-font-kerning);font-kerning:var(--one-typography-desktop-caption-font-kerning);font-weight:var(--one-text-font-weight-regular);height:var(--one-spacing-size-xs);width:inherit;color:var(--one-color-foreground-base);overflow:hidden;text-overflow:ellipsis}.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar{position:relative;height:var(--one-spacing-size-5-xs);width:inherit;overflow:hidden;background-color:var(--one-color-background-brand-lower);border-radius:var(--one-spacing-radius-100)}.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{border-radius:inherit;background-color:var(--one-color-foreground-brand-base)}.owc-progress-bar--mode-determinate.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{width:100%;height:100%;-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-transition:-webkit-transform 0.4s linear;transition:-webkit-transform 0.4s linear;transition:transform 0.4s linear;transition:transform 0.4s linear, -webkit-transform 0.4s linear}.owc-progress-bar--mode-indeterminate.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{position:absolute;height:inherit;will-change:left, right;-webkit-animation:indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;animation:indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite}.owc-progress-bar--variant-secondary.sc-owc-progress-bar-h:not(.owc-progress-bar--disabled)>.owc-progress-bar__container.sc-owc-progress-bar{background-color:var(--one-color-background-contrast)}.owc-progress-bar--variant-secondary.sc-owc-progress-bar-h:not(.owc-progress-bar--disabled)>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{background-color:var(--one-color-foreground-base)}.owc-progress-bar--mode-determinate.owc-progress-bar--status-alarm.sc-owc-progress-bar-h:not(.owc-progress-bar--disabled)>.owc-progress-bar__container.sc-owc-progress-bar{background-color:var(--one-color-background-intensity-low)}.owc-progress-bar--mode-determinate.owc-progress-bar--status-alarm.sc-owc-progress-bar-h:not(.owc-progress-bar--disabled)>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{background-color:var(--one-color-foreground-negative-base);-webkit-transform:translateX(100%);transform:translateX(100%)}.owc-progress-bar--mode-determinate.owc-progress-bar--status-positive.sc-owc-progress-bar-h:not(.owc-progress-bar--disabled)>.owc-progress-bar__container.sc-owc-progress-bar{background-color:var(--one-color-background-intensity-low)}.owc-progress-bar--mode-determinate.owc-progress-bar--status-positive.sc-owc-progress-bar-h:not(.owc-progress-bar--disabled)>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{background-color:var(--one-progress-bar-color-primary-positive-foreground)}.owc-progress-bar--mode-determinate.owc-progress-bar--status-positive.owc-progress-bar--variant-secondary.sc-owc-progress-bar-h:not(.owc-progress-bar--disabled)>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{background-color:var(--one-progress-bar-color-secondary-positive-foreground)}.owc-progress-bar--disabled.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar{background-color:var(--one-color-interaction-disabled-intensity-low)}.owc-progress-bar--disabled.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{background-color:var(--one-color-interaction-disabled-intensity-low)}@media (forced-colors: active){.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar{background-color:background;border:var(--one-spacing-outline-regular) solid canvastext}.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{background-color:canvastext}.owc-progress-bar--variant-secondary.sc-owc-progress-bar-h:not(.owc-progress-bar--disabled)>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{background-color:canvastext}.owc-progress-bar--disabled.sc-owc-progress-bar-h>.owc-progress-bar__container.sc-owc-progress-bar>.owc-progress-bar__container__bar.sc-owc-progress-bar{background-color:background}}";
const OwcProgressBarStyle0 = progressBarCss;
const FULL = 100;
const HALF = 50;
const ProgressBar = /*@__PURE__*/proxyCustomElement(class ProgressBar extends H {
  constructor() {
    super();
    this.__registerHost();
    this.bar = useRef();
    this.component = new ComponentUtils(this);
    this.getAccessibilityAttributes = () => {
      if (this.mode === 'determinate') {
        return Object.assign({}, accessibility({
          role: 'progressbar',
          aria: {
            label: this.caption,
            valuemin: 0,
            valuemax: FULL,
            valuenow: this.value,
            valuetext: `${this.value} %`
          }
        }));
      }
      return Object.assign({}, accessibility({
        role: 'progressbar',
        aria: {
          label: this.caption
        }
      }));
    };
    this.hostId = generateElementId(this.hostElement);
    this.mode = 'indeterminate';
    this.variant = 'primary';
    this.status = 'default';
    this.disabled = false;
    this.caption = '';
    this.value = HALF;
  }
  handleValue() {
    var _a, _b;
    if (this.mode === 'determinate') {
      const valueRectified = Math.max(0, Math.min(FULL, this.value));
      (_a = this.bar.current) === null || _a === void 0 ? void 0 : _a.style.setProperty('transform', `translateX(${valueRectified - FULL}%)`);
    } else {
      (_b = this.bar.current) === null || _b === void 0 ? void 0 : _b.style.removeProperty('transform');
    }
  }
  componentDidLoad() {
    this.handleValue();
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      [`variant-${this.variant || 'primary'}`]: true,
      [`mode-${this.mode || 'indeterminate'}`]: true,
      [`status-${this.status || 'default'}`]: true,
      disabled: this.disabled
    });
    const containerClasses = this.component.getChildBemClasses('container', hostClasses);
    const barClasses = this.component.getChildBemClasses('bar', containerClasses);
    return h(Host, Object.assign({
      key: '23b3b3b50fc3bb4c5ab89150395ad02931b80c88',
      class: hostClasses
    }, this.getAccessibilityAttributes()), this.caption ? h("label", {
      htmlFor: this.hostId
    }, this.caption) : null, h("div", {
      key: '4112019b54256c62a77005dc667339c3290d814f',
      class: containerClasses
    }, h("div", {
      key: '67350649e6ad95bbe2c2cdd8ee749068e8bf3af8',
      ref: this.bar,
      class: barClasses
    })));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "value": ["handleValue"],
      "mode": ["handleValue"]
    };
  }
  static get style() {
    return OwcProgressBarStyle0;
  }
}, [2, "owc-progress-bar", {
  "hostId": [1537, "id"],
  "mode": [513],
  "variant": [513],
  "status": [513],
  "disabled": [516],
  "caption": [513],
  "value": [514]
}, undefined, {
  "value": ["handleValue"],
  "mode": ["handleValue"]
}]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-progress-bar"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-progress-bar":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, ProgressBar);
        }
        break;
    }
  });
}
export { ProgressBar as P, defineCustomElement as d };